export const IN_APP_CONTENT_TYPE__WELCOME = 'welcome';
export const IN_APP_CONTENT_TYPE__FAQ = 'FAQ';
export const IN_APP_CONTENT_TYPE__MEDICAL_INFORMATION = 'medical_information';
export const IN_APP_CONTENT_TYPE__AUTHENTICATION = 'authentication';
export const IN_APP_CONTENT_TYPE__PROJECT_DETAILS = 'project_details';
export const IN_APP_CONTENT_TYPES = [
  IN_APP_CONTENT_TYPE__WELCOME,
  IN_APP_CONTENT_TYPE__FAQ,
  IN_APP_CONTENT_TYPE__AUTHENTICATION,
  IN_APP_CONTENT_TYPE__MEDICAL_INFORMATION,
  IN_APP_CONTENT_TYPE__PROJECT_DETAILS,
];

// Maximum number of matching PatientRecord rows (participation-level rows, not
// unique recipients) that a single scoped "Sync to Patient Service" run may
// replay. Shared so the DashboardTimeline gate and the authoritative
// server-side check cannot drift apart.
export const PTA_RESYNC_MAX_PATIENT_RECORDS = 100000;

// Backstop for the bulk "re-send reminders" action. Unlike
// PTA_RESYNC_MAX_PATIENT_RECORDS this does not bound database writes - it bounds
// how much real patient messaging one click can start, so it is a safety limit
// rather than a performance one.
//
// Named for ACTIVITIES, not messages, because that is what it actually bounds
// and the distinction is not cosmetic: one activity produces one message per
// notification group per destination, so an activity with an SMS and an email
// destination sends two. Counting messages up front would mean evaluating each
// project's notifications program for every activity in the cohort - the exact
// work that is deferred to the worker precisely because it is too slow to do in
// a method call. So the ceiling counts what can be counted cheaply, and both the
// limit and the confirmation dialog say "activities" rather than implying a
// message count nobody has measured.
//
// It is deliberately not the operator's primary control: the action counts the
// cohort first and requires the number to be confirmed, which is what catches a
// filter that selected more than intended. This ceiling only stops a runaway.
export const PTA_RESEND_MAX_ACTIVITIES = 25000;
